import { useTranslation } from "react-i18next";
import { Building2, ScanEye, ShieldAlert, Users } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

const CARDS = [
  ["companies", "companies", Building2, false],
  ["activeCompanies", "active_companies", Building2, true],
  ["suspended", "suspended_companies", ShieldAlert, false],
  ["users", "users", Users, false],
  ["verifications", "face_verifications_month", ScanEye, true],
  ["pendingRequests", "pending_requests", Users, false],
];

export const PlatformStats = ({ stats }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6" data-testid="platform-stats">
      {CARDS.map(([key, field, icon, accent]) => (
        <StatCard
          key={key}
          testId={`platform-stat-${key}`}
          label={t(`platform.${key}`)}
          value={stats?.[field] ?? 0}
          icon={icon}
          accent={accent}
        />
      ))}
    </div>
  );
};
